function ChevronDown() {
  return (
    <svg width={40} height={22} viewBox="0 0 40 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.685.953l-.637-.637a1.077 1.077 0 00-1.524 0L20.005 17.844 2.477.316a1.077 1.077 0 00-1.524 0L.316.953a1.077 1.077 0 000 1.524l18.918 18.927a1.077 1.077 0 001.524 0L39.676 2.477c.43-.422.43-1.103.01-1.524z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default ChevronDown;
